import en from './en';

const ms = {
  ...en,
  languageSwitcher: {
    label: 'Bahasa',
    options: {
      en: 'EN',
      ja: 'JA',
      ko: 'KO',
      ms: 'MS',
      th: 'TH',
      tr: 'TR',
    },
    names: {
      en: 'Inggeris',
      ja: 'Jepun',
      ko: 'Korea',
      ms: 'Melayu',
      th: 'Thai',
      tr: 'Turki',
    },
  },
  nav: {
    home: 'Laman Utama',
    privacy: 'Privasi',
    terms: 'Terma',
    smsOptIn: 'Pengesahan SMS',
    guidelines: 'Garis Panduan',
    safety: 'Keselamatan',
    deleteAccount: 'Padam Akaun',
    support: 'Sokongan',
    download: 'Muat Turun',
    brandAriaLabel: 'Laman Utama 7Loves',
    menuAriaLabel: 'Buka menu',
  },
  store: {
    groupAriaLabel: 'Pautan stor',
    appStoreAriaLabel: 'Muat turun di App Store',
    appStoreOverline: 'Muat turun di',
    appStoreTitle: 'App Store',
    googlePlayAriaLabel: 'Dapatkan di Google Play',
    googlePlayOverline: 'Dapatkan di',
    googlePlayTitle: 'Google Play',
  },
  home: {
    metaTitle: 'Laman Utama',
    title: 'Selamat datang ke 7Loves',
    subtitle: 'Blind Date - Padan dahulu. Kenali lebih lagi kemudian.',
    intro:
      'Seven Loves ialah aplikasi janji temu moden yang memfokuskan pada hubungan yang bermakna. Tidak seperti aplikasi berasaskan swipe tradisional, Seven Loves memperkenalkan pengalaman blind-match yang unik di mana pengguna berhubung dahulu dan profil didedahkan secara beransur-ansur.',
    howItWorks: 'Cara Ia Berfungsi',
    details:
      'Pengguna dipadankan berdasarkan keserasian, memulakan perbualan, dan membuka butiran profil dari semasa ke semasa. Pendekatan ini menggalakkan hubungan yang tulen berbanding swipe yang cetek.',
    primaryCta: 'Muat Turun',
    secondaryCta: 'Hubungi Kami',
  },
  downloadPage: {
    metaTitle: 'Muat Turun',
    title: 'Dapatkan 7Loves',
    subtitlePrefix: 'Anda boleh terus ke',
    subtitleSuffix: 'dari sini.',
    fallback: 'Jika mahu, anda juga boleh menggunakan pautan stor di bawah.',
    modalTitle: 'Buka stor?',
    modalBodyPrefix: 'Kami boleh cuba membuka',
    modalBodySuffix: 'pada peranti ini.',
    primaryCta: 'Buka Stor',
    secondaryCta: 'Bukan Sekarang',
    backHome: 'Kembali ke Laman Utama',
    destinations: {
      ios: 'App Store',
      android: 'Google Play',
    },
  },
  smsOptIn: {
    metaTitle: 'Persetujuan Pengesahan SMS',
    title: 'Persetujuan Pengesahan SMS',
    subtitle:
      'Untuk menerima kod pengesahan sekali guna, sila sahkan bahawa anda berumur 18 tahun ke atas dan masukkan nombor telefon mudah alih anda.',
    dobLabel: 'Tarikh Lahir (DD/MM/YYYY)',
    dayPlaceholder: 'DD',
    monthPlaceholder: 'MM',
    yearPlaceholder: 'YYYY',
    phoneLabel: 'Nombor Telefon Mudah Alih',
    phonePlaceholder: '+60 12 000 0000',
    sendCode: 'Hantar Kod Pengesahan',
    disclosure:
      'Dengan mengetik “Hantar Kod Pengesahan”, anda mengesahkan bahawa anda berumur 18 tahun ke atas dan bersetuju untuk menerima kod pengesahan SMS sekali guna daripada Seven Loves untuk tujuan pengesahan. Kadar mesej dan data mungkin dikenakan. Tiada mesej pemasaran akan dihantar.',
    privacyLink: 'Dasar Privasi',
  },
  pages: en.pages,
};

export default ms;
